/*
 * Copyright (c) 2018. keni <$email>
 *
 * This file PublicMessenger.js is part of event_pass_client.dev.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 * PublicMessenger.js can not be copied and/or distributed
 * without the express permission of keni
 */

/**
 * Created by matos on 31/05/2017.
 */
export function PublicMessenger(options = {}){

	let messengerPlugin = {
		data:{
			box_state: 'closed',
			user_data: {},
			is_typing_trigger: false,
			is_typing_trigger_timer: null,
			issue_reference: '',
			sending_message: false,
			support_user: null,
			update_call: null,
			listening: false,
			messages:[]
		},

		elements:{
			main_box: $(`.chat_system--box`),
			main_box_content: $(`.chat_system--box-content`),
			box_content_messages: $(`.chat_system--box-content-messages`),

			small_closed_button: $(`.chat_system--closed`),

			box_close_button: $(`.chat_system--box-header-right-close_button`),

			control_content: $(`.chat_system--box-content-control`),
			send_message_button: $(`.chat_system--box-content-control-send_button`),
			message_input: $(`.chat_system--box-content-control-message_input`),

			header: $(`.chat_system--box-header-left`),
			title: $(`.chat_system--box-header-left-title`)

		},

		tags:{
			queue_pos_elem: 'chat_system--tag-queue_pos',
			is_typing: 'chat_system--tag-is_typing'
		},

		html_blocks:{
			support_not_available:
				'<div class="chat_system--box-content-messages-warn">' +
				'   <div>' +
				'       There is no support available at this moment' +
				'   </div>' +
				'   <div>' +
				'       Our offices operate from <b>9:00am</b> to <b>5:30pm</b>' +
				'   </div>' +
				'   <div>' +
				'       Please use other means of contact: <a href="'+options.contact_us_url+'">Contact Us</a>' +
				'   </div>' +
				'</div>',
			user_in_queue:
				'<div class="chat_system--box-content-messages-warn">' +
				'   <span>You are number </span>' +
				'   <span class="chat_system--tag-queue_pos"></span>' +
				'   <span> in the queue.</span>' +
				'</div>',
			close_issue:
				'<div class="chat_system--box-content-messages-warn">' +
				'   <span>The support user close this conversation.</span>' +
				'</div>'
		},

		appendMessage:function (usr, msg){
			while (msg.indexOf("\n") !== -1)
				msg = msg.replace("\n", "<br />");

			let
				message = '' +
					'<div class="chat_system--box-content-left-messages-message">' +
					'   <span class="chat_system--box-content-left-messages-message-user">' + usr + ':</span>' +
					'   <span class="chat_system--box-content-left-messages-message-body">' + msg + '</span> ' +
					'</div>',
				msgObject = $(message);

			this.elements.box_content_messages
				.append(msgObject)
				.animate({ scrollTop: this.elements.box_content_messages.height() }, 50);

			if (usr === "me"){
				msgObject.find(`.chat_system--box-content-left-messages-message-user`).addClass("chat_system--tag-self");
			}

			this.elements.box_content_messages.append(msgObject);

			this.showBox();
		},

		showBox:function (){
			$(`.chat_system--closed`).hide();
			$(`.chat_system--box`).show();
			$(`.chat_system--box-content`).show();

			this.data.box_state = "open";
			this.saveData();
		},
		hideBox:function (){
			$(`.chat_system--closed`).show();
			$(`.chat_system--box`).hide();
			$(`.chat_system--box-content-control`).hide();

			this.data.box_state = "closed";
			this.saveData();
		},
		changeName:function (name){
			$(`.chat_system--box-header-left-title`).html(name);
		},

		userIsTyping:function (){
			let
				_this = this,
				channel = _this.data.user_data.id;

			if (!_this.data.is_typing_trigger){
				_this.data.is_typing_trigger = true;

				axios.post(options.action, {
					action: "is_typing",
					user_typing: _this.data.user_data,
					user_in_conversation: _this.data.support_user,
					channel: channel
				})
					.then(function (response) {
						if (response.data.successful) {

						}
					})
					.catch(function (error){

					});

				_this.data.is_typing_trigger_timer = setInterval(()=>{
					_this.data.is_typing_trigger = false;
					clearInterval(_this.data.is_typing_trigger_timer);

					axios.post(options.action, {
						action: "stop_typing",
						user_typing: _this.data.user_data,
						user_in_conversation: _this.data.selected_user,
						channel: channel
					});
				}, 2000);
			}
			else {
				clearInterval(_this.data.is_typing_trigger_timer);

				_this.data.is_typing_trigger_timer = setInterval(()=>{
					_this.data.is_typing_trigger = false;
					clearInterval(_this.data.is_typing_trigger_timer);

					axios.post(options.action, {
						action: "stop_typing",
						user_typing: _this.data.user_data,
						user_in_conversation: _this.data.support_user,
						channel: channel
					});
				}, 2000);
			}
		},

		readInitialData:function (){
			this.readData();

			this.data.sending_message = false;

			switch (this.data.box_state){
				case "closed":
					this.hideBox();
					break;
				case "open":
					this.showBox();
					break;
			}
		},

		readData:function (){
			let data = sessionStorage.getItem(options.local_storage_item);

			if (data){
				this.data = JSON.parse(data);
			}
		},
		saveData:function (){
			let json_data = JSON.stringify(this.data);
			sessionStorage.setItem(options.local_storage_item, json_data);
		},


		closeIssue:function (){
			let _this = this;

			_this.showBox();

			clearInterval(_this.data.update_call);

			CoreEcho.leave(options.channel + "." + _this.data.user_data.id);

			_this.elements.control_content.hide();
			_this.elements.box_content_messages.append(_this.html_blocks.close_issue);

			_this.data.box_state = "closed";
			_this.data.user_data = null;
			_this.data.support_user = null;
			_this.data.update_call = null;
			_this.data.listening = false;

			_this.saveData();
		},



		updateCall:function (){
			let _this = this;

			axios.post(options.request_data, {
				request: 'get_data'
			})
				.then(function (response) {
					if (response.data.successful){
						if (response.data.queue_pos === -1 && response.data.status === "none"){
							_this.elements.box_content_messages.html($(_this.html_blocks.support_not_available));

							CoreEcho.leave(options.channel + "." + _this.data.user_data.id);
							_this.data.listening = false;

							clearInterval(_this.data.update_call);
							_this.data.update_call = null;
						}
						else if (response.data.status === "user_canceled"){
							_this.closeIssue();
						}
						else if (response.data.status === "user_in_conversation"){
							$(`.chat_system--box-content-control`).show();
						}
						else if (response.data.status === "user_in_queue") {
							console.log("User is in queue?");
							_this.data.messages = [];
						}
					}
					else {
						//@todo what to do when timeout??
						console.error("You got knocked out!", response.data);
					}
				})
				.catch(function (error){
					console.error(error);
				});
		},



		sendMessage:function (usr, msg){
			let _this = this;

			//if the message is not empty
			if (msg.trim().length >= 1){
				if (_this.data.sending_message){
					return false;
				}

				_this.data.sending_message = true;

				_this.elements.message_input.val(""); //clear the input

				//let's make the call to send the message
				axios.post(options.action, {
					action: "send_message",
					sender: this.data.user_data,
					receiver: this.data.support_user,
					channel: this.data.user_data.id,
					message: msg,
					issue_reference: this.data.issue_reference
				})
					.then(function (response) {
						if (response.data.successful){
							_this.data.messages.push({
								sender: _this.data.user_data,
								receiver: _this.data.support_user,
								message: msg
							});

							_this.saveData();

							_this.appendMessage(usr, msg);
							_this.data.sending_message = false;
						}
					})
					.catch(function (error){
						console.error(error);
					});
			}
		},


		setup:function (data) {
			let _this = this;

			this.readInitialData();

			this.data.user_data = {
				id: data.user_hash,
				email: data.user_email,
				name: data.user_name
			};
			this.data.issue_reference = data.issue_reference;

			//send message button
			this.elements.send_message_button.click(function (){
				let
					usr =  'me',
					msg = _this.elements.message_input.val(); //grabbing the message

				_this.sendMessage(usr, msg);
			});


			//if the user presses control + enter on the chat box will send the message
			this.elements.message_input
				.keyup(function(event){
					if(event.keyCode === 13 && event.ctrlKey){
						_this.elements.send_message_button.click();
					}
				})
				.on('input propertychange', function (){
					_this.userIsTyping();
				});

			//header handle
			this.elements.box_close_button.click((e) => {
				_this.hideBox();
			});

			//Check if user did entered the queue
			if (data.queue_pos === -1){
				//if so, there is no admins available, lets display generic message
				this.elements.box_content_messages.html($(this.html_blocks.support_not_available));

				//if a prev timer was set, lets clear it
				if (_this.data.update_call){
					window.clearInterval(_this.data.update_call);
					_this.data.update_call = null;
				}
			}
			else {
				if (!_this.data.listening){
					//Setting up a timer for update call
					if (data.status === "user_in_queue" ||
						data.status === "user_in_conversation"){

						if (!_this.data.update_call){
							_this.data.update_call = window.setInterval(function (){
								_this.updateCall();
							}, options.update_me_timeout * 1000);
						}
					}

					_this.data.listening = true;

					CoreEcho.join(options.channel + "." + data.user_hash)
						.here((users) =>{
							if (users.length > 1){
								//we are already in a conversation
								_this.data.messages.forEach(function (e){
									if (e.receiver.id === _this.data.user_data.id){
										_this.appendMessage("me", e.message);
									}
									else {
										_this.appendMessage(e.sender.name, e.message);
									}
								});
							}
						})
						.joining((user) => {
							_this.data.support_user = user;
							_this.saveData();

							if (data.status === "user_in_queue"){
								//first connect
								_this.elements.box_content_messages.html("");
							}

							_this.elements.control_content.show();
						})
						.leaving((user) => {

						})
						.listen('.' + options.new_message_event, function (e){
							if (e.message.receiver.id === data.user_hash){
								$('.' + _this.tags.is_typing).remove();

								_this.data.messages.push({
									sender: e.message.sender,
									receiver: _this.data.user_data,
									message: e.message.message
								});

								_this.saveData();
								_this.appendMessage(e.message.sender.name, e.message.message);
							}
						})
						.listen('.' + options.update_queue_pos, function (e){
							$('.' + _this.tags.queue_pos_elem).html(e.user.queue_pos);
						})
						.listen('.' + options.close_issue, function () {
							_this.closeIssue();
						})
						.listen('.' + options.user_is_typing, function (e){
							if (e.is_typing){
								_this.elements.header.append(
									'<span class="' + _this.tags.is_typing + '">{...}</span>'
								);
							}
							else {
								$('.' + _this.tags.is_typing).remove();
							}
						});
				}

				switch (data.status){
					case "user_in_queue" :
						let message = $(this.html_blocks.user_in_queue);

						this.elements.box_content_messages.html($(this.html_blocks.user_in_queue));
						$('.' + _this.tags.queue_pos_elem).html(data.queue_pos);

						this.data.messages = [];
						this.saveData();
						
						break;
					case "user_in_conversation":
						this.elements.control_content.show();
						break;
				}
			}

			this.saveData();
		},

		init:function (options){
			let
				_this = this,
				public_functionality = {
					show: function () {
						_this.showBox();
					},
					hide: function (){
						_this.hideBox();
					},
					title: function (name){
						_this.changeName(name);
					},
					__getData:function(){
						return _this.data;
					}
				};

			this.readData();
			this.data.listening = false;
			this.data.update_call = null;
			this.saveData();

			this.elements.small_closed_button.click(function () {
				public_functionality.show();

				//When the user pops the messaging system, we are going to request the initial setup

				axios.post(options.request_data, {
					request: "get_data"
				})
					.then(function (response) {
						if (response.data.successful){
							_this.setup(response.data);

							return public_functionality;
						}
						else {
							//Something wen't badly wrong
							$(`.chat_system`).remove();
							return null;
						}
					})
					.catch(function (error){
						//User is not valid
						$(`.chat_system`).remove();
						return null;
					});
			});

			if (this.data.box_state === "open" || this.data.support_user){
				this.elements.control_content.hide();
				this.elements.small_closed_button.click();
			}
			else {
				this.hideBox();
			}

			return public_functionality;
		}
	};

	return messengerPlugin.init(options);
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/front/notifications/PublicMessenger.js